import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankSuccessPage} from 'features/saved-accounts/pages/ConnectBankSuccessPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/connect-bank/success',
)({
  component: ConnectBankSuccessPage,
});
